import React from 'react';
import { gql } from '@apollo/client';
import { SignupController, SignupControllerProps } from './Signup.controller';
import { SocialAuthTokenQuery, useSocialAuthTokenLazyQuery } from '../../../models/graphql';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';

export type SocialAuthTokenDataType = (SocialAuthTokenQuery['socialAuthToken'] & { clientToken?: string }) | undefined;

gql`
  query SocialAuthToken($clientToken: String!) {
    socialAuthToken(socialAuthToken: $clientToken) {
      ...SocialAuthTokenFields
    }
  }
`;

export type SignupApolloProps = Omit<
  SignupControllerProps,
  | 'initialStep'
  | 'submitted'
  | 'signupError'
  | 'signupQuery'
  | 'signupData'
  | 'setSocialSignupCancelCounter'
  | 'socialSignupCancelCounter'
> & {
  //
};

export const SignupApollo = (props: SignupApolloProps): JSX.Element => {
  const [signupQuery, { loading, data, error, variables }] = useSocialAuthTokenLazyQuery({
    fetchPolicy: 'no-cache'
  });

  let submitted = false;
  let signupError: string | JSX.Element = '';

  let initialStep: 1 | 2 = 1;
  let signupData: undefined | SocialAuthTokenDataType;

  if (loading) {
    submitted = true;
    signupError = '';
  }
  if (error) {
    submitted = false;
    signupError = remapApolloErrors(error);
  }
  if (data) {
    signupError = '';
    submitted = false;
    signupData = data.socialAuthToken;
    signupData.clientToken = variables?.clientToken;
    initialStep = 2;
  }

  const controllerProps: SignupControllerProps = {
    ...props,
    initialStep,
    submitted,
    signupError,
    signupData,
    signupQuery
  };
  return <SignupController {...controllerProps} />;
};
